module.exports = __webpack_public_path__ + "static/img/empty.f18b6a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty.png
// module id = Bm30
// module chunks = 2